let services = {
  title: 'Serviços',
  title_s: 'Serviço',
  categories: 'Categorias de Serviços',
  new: {
    title: 'Novo Serviço',
    close: 'Fechar',
    all: 'Todas',
    all_cat: 'Todas Categorias',
    category: 'Categoria',
    noChildrenText: 'Nenhuma Sub-Categoria',
    noCategoriesText: 'Sem Categorias',
    noResultsText: 'Categoria não encontrada',
    rules: {
      titleRules: [
        v => !!v || 'Título é obrigatório',
        v => (v && v.length <= 74) || 'O Título deve ter menos que 74 caracteres'
      ],
      categoryRules: [
        v => !!v || 'Categoria é obrigatório'
      ]
    }
  },
  edit: {
    title: 'Editar Serviço'
  },
  actions: {
    new: 'Novo',
    edit: 'Editar',
    save: 'Salvar',
    delete: 'Excluir'
  },
  status: {
    active: 'Ativo',
    inactive: 'Inativo',
    activate: 'Ativar',
    deactivate: 'Desativar'
  },
  dialog: {
    deleteConfirm: 'Tem certeza que deseja excluir o Serviço'
  },
  datatable: {
    search: 'Pesquisar',
    no_data: 'Nenhum serviço cadastrado',
    no_results: 'Nenhum resultado encontrado',
    items_per_page: 'Serviços por página',
    headers: {
      id: 'ID',
      code: 'Cod',
      created: 'Criação',
      category: 'Categoria',
      title: 'Título',
      description: 'Descrição',
      price: 'Preço',
      action: 'Ações'
    }
  },
  messages: {
    error: {
      not_found: 'Serviço não encontrado'
    }
  }
}

export default services
